import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { StyledTextBox } from "@animech/ui";

export const Text = styled.p``;

export const SendEmailModalContent = styled.div`
	${({ theme }) => css`
		${Text} {
			line-height: 1.3;
		}
		${StyledTextBox.Root} {
			margin-bottom: ${theme.dimensions.margin.base};
		}
	`}
`;
